import { Component, Vue, Prop } from 'vue-property-decorator';
import { ProductVariant } from '@/models/ProductVariant';
import { addClass, removeClass } from '@/support/Html';
import { Attribute } from '@/models/Attribute';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';

@Component<AddProductAttributesDialog>({})
export default class AddProductAttributesDialog extends Vue {

  @Prop({ default: () => new ProductVariant() })
  protected product!: ProductVariant;

  @Prop({ default: false })
  protected isCopyToAVariantFlow!: boolean;

  @Prop({ default: () => [] })
  protected productAttributeSummary!: any[];

  protected isLoading = false;

  protected selectedProducts: ProductVariant[] = [];

  protected selectedAttributes: AttributeItemInterface[] = [];

  protected currentStep: number = 1;

  protected attributes: Attribute[] = [];

  protected mounted(): void {
    this.initialize();
  }

  protected async initialize(): Promise<void> {
    const pageHtml = document.querySelectorAll('html')[0];
    addClass(pageHtml, 'overflow-y-hidden');
    await this.getAttributes();
    this.combineProducts();
  }

  // #region @PropSyncs
  // #endregion

  // #region @Props
  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Lifecycle Hooks / Init
  // #endregion

  // #region Handlers

  protected onClose(): void {
    this.close();
  }

  protected async onNextFromOverview(): Promise<void> {
    this.isLoading = true;

    await this.create();

    this.isLoading = false;

    this.currentStep += 1;
  }

  // #endregion

  // #region Helpers

  protected async create(): Promise<void> {
    await this.addAttributes();
  }

  protected async addAttributes() {
    let attributePromises = this.selectedAttributes.map(attribute => this.attachAttribute(attribute));

    if (this.isCopyToAVariantFlow) {
      this.productAttributeSummary.forEach((attributeSummary) => {
        attributePromises = [
          ...attributePromises,
          ...attributeSummary.values.map((attr: any) => {
            const attribute = this.attributes.find((attribute) => attribute.title === attr.attribute.title);

            return this.attachAttribute({
              attribute: attribute ? attribute.id : '',
              option: attr.option.id,
            })
          }),
        ];
      });
    }

    await Promise.all(attributePromises);
    this.$emit('attributesCreated');
    this.close();
  }

  protected close(): void {
    this.$emit('input', false);
    const pageHtml = document.querySelectorAll('html')[0];
    removeClass(pageHtml, 'overflow-y-hidden');
  }

  protected combineProducts() {
    if (this.selectedProducts.some((product: ProductVariant) => product.id === this.product.id )) {
      return;
    }
    this.selectedProducts.push(this.product);
  }

  // #endregion

  // #region Async methods

  protected async attachAttribute(entry: AttributeItemInterface): Promise<void | Attribute> {
    if (!this.selectedProducts) {
      return;
    }

    const variants = this.selectedProducts.map(product => product.id);


    let payload = {
      product_variants: variants,
      attribute: entry.attribute,
      option: entry.option,
    };

    await new Attribute()
      .addAttributeToProducts(payload)
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected async getAttributes() {
    await new Attribute().include('options')
      .limit(100)
      .all()
      .then((attributes: Attribute[]) => {
        this.attributes = attributes;
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers
  // #endregion
}

// #region Enums
// #endregion

// #region Types
// #endregion

// #region Interfaces

export interface AttributeItemInterface {
  attribute?: string;
  option?: string;
}

// #endregion
